export type StringKey<T> = keyof T & string;
